import { defineStore } from 'pinia'

type TStoreState = {
    isOpen: object
};

export const useChapterStore = defineStore('chapters', {
  state: (): TStoreState => {
    return {
      isOpen: {}
    }
  },
  actions: {
    setIsOpen (pageId: number, newValue: boolean) {
      this.$state.isOpen[pageId] = newValue
    },
    getOpen (pageId: number) {
      return this.$state.isOpen[pageId]
    }
  },
  getters: {
    getIsOpen: state => state.isOpen
  }
})
